import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

import { useRepository } from '@/Application/Providers/Repository';
import type { RootState } from '@/Infrastructure/State';
import { getAlternativePayments } from '@/modules/cart/application/getAlternativePayments';
import type { Cart } from '@/modules/cart/domain/Cart';

export const selectCartPayments = createSelector(
  (state: RootState) => state.cartPayments,
  (cartPayments) => ({
    data: cartPayments?.data,
    isLoading: cartPayments?.isLoading,
    error: cartPayments?.error
  })
);

const useCartPayments = (cart: Cart | undefined) => {
  const {
    data: cartPayments,
    isLoading,
    error
  } = useSelector(selectCartPayments);

  const { cartPaymentsRepository } = useRepository();

  const fetchCartPayments = useCallback(async () => {
    return getAlternativePayments(cartPaymentsRepository);
  }, [cartPaymentsRepository]);

  useEffect(() => {
    if (cart?.id) {
      fetchCartPayments();
    }
  }, [cart, fetchCartPayments]);

  return {
    cartPayments,
    isLoading,
    error
  };
};

export default useCartPayments;
